import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalService } from "app/services/local.service";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CustomersService {
  apiUrl = "";
  // JSON.parse(localStorage.getItem("client"))["apiUrl"] || environment.apiUrl;

  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }

  //Auto Complete Customer Name Service

  /**
   *
   * @param term String
   *
   * Filter mathod for Customers
   */
  getUserName(term: any) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "customer/searchUser",
        { search: term },
        {
          headers: headers,
        },
      )
      .pipe(map((response) => response["Data"]));
  }
  searchCustomer(search: {}): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "customer/searchUser", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  createCustomerAdmin(data: {}): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "customer/createCustomerAdmin/", data, {
        headers: headers,
      })
      .map((respoonse) => respoonse)
      .toPromise();
  }
  listingCustomerAdmin(data: {}): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "aggregator/listing-analytics/getCustomerList/",
        data,
        {
          headers: headers,
        },
      )
      .map((respoonse) => respoonse)
      .toPromise();
  }
  blockUnblockCustomer(data: {}): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "customer/blockCustomer", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  enabledDisablesCOD(data: {}): Promise<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(this.apiUrl + "customer/codUpdate", data, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  filterCustomer(term: any) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "customer/searchUser",
        { autosearchUser: term },
        {
          headers: headers,
        },
      )
      .pipe(
        map((response) =>
          response["Data"].filter((option) => {
            return option.search.indexOf(term) === 0;
          }),
        ),
      );
  }

  getCustomerCount(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .get(this.apiUrl + "customer/getCustomerCount", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
}
